module.exports = __webpack_public_path__ + "static/media/55_000048.22935f25.jpg";